import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, take, tap, timeout } from 'rxjs/operators';
import { NotificacaoDestino } from '../_classes/notificacao-destino';
import { Retorno } from '../_classes/retorno';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  private headers: HttpHeaders = new HttpHeaders();
  private urlBase = 'serv/notificacao';

  private delay = 0;
  private timeout = 15000;

  constructor(private env: EnvService, private http: HttpClient) {
    this.headers.append('Content-Type', 'application/json');
    this.timeout = env.timeoutGenerico;
  }

  public getApiUrl(): string {
    return `${this.env.apiUrl}`;
  }

  public log(msg: string, obj: any, erro: boolean = false) {
    if (this.env.enableDebug) {
      erro ? console.error(msg, obj) : console.log(msg, obj);
    }
  }

  marcarComo(
    notificacao: NotificacaoDestino,
    tipo: string
  ): Observable<Retorno> {
    let endpoint: string = this.urlBase;
    if (tipo == 'L') {
      endpoint += '/registrar/responder';
    } else if (tipo == 'I') {
      endpoint += '/registrar/ignorar';
    } else if (tipo == 'V') {
      endpoint += '/registrar/visualizar';
    }

    const restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .post<NotificacaoDestino>(
        this.getApiUrl() + '/' + restoUrl,
        notificacao,
        {
          headers: this.headers,
        }
      )
      .pipe(
        tap(console.log),
        timeout(this.timeout),
        delay(this.delay),
        take(1)
      );
  }

  listarNotificacoesMinhasNaoRespondidas(
    servidor: string
  ): Observable<Retorno> {
    let endpoint: string = this.urlBase + '/nao-respondidas/listar/' + servidor;
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  listarNotificacoesMinhas(servidor: string): Observable<Retorno> {
    let endpoint: string = this.urlBase + '/listar/' + servidor;
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  contarNotificacoesMinhasNaoRespondidas(
    servidor: string
  ): Observable<Retorno> {
    //console.log('contando...');
    let endpoint: string = this.urlBase + '/nao-respondidas/contar/' + servidor;
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  /*

  listarEstatisticaAcessoComPeriodo(dtInicio: Date, dtFim: Date) {
    let datas: Periodo = new Periodo();
    datas.dtFinal = dtFim;
    datas.dtInicial = dtInicio;

    let endpoint: string = 'geral/recursos-estatistica-2';
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .post<Retorno>(this.getApiUrl() + '/' + restoUrl, datas, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }*/
}
